export default __webpack_public_path__ + "static/media/no-pizzas.089b753c.svg";